import React from "react";
import { AccordionItemState } from "react-accessible-accordion";
import Icon from "../Icon/Icon.component";
import {
  StyledAccordion,
  StyledAccordionItem,
  StyledAccordionItemButton,
  StyledAccordionItemHeading,
  StyledAccordionItemPanel,
  StyledIcon,
} from "./FaqList.styled";

export interface IQuestion {
  question: string;
  answer: string;
}

interface IFaqList {
  questions: IQuestion[];
}

const FaqList = ({ questions }: IFaqList) => (
  <StyledAccordion
    allowZeroExpanded
    preExpanded={questions.length ? ["faq-0"] : []}
  >
    {questions.map((item, index) => (
      <StyledAccordionItem key={item.question} uuid={`faq-${index}`}>
        <StyledAccordionItemHeading>
          <StyledAccordionItemButton>
            {item.question}
            <AccordionItemState>
              {({ expanded }) => (
                <StyledIcon isOpen={expanded}>
                  <Icon name="plus" />
                </StyledIcon>
              )}
            </AccordionItemState>
          </StyledAccordionItemButton>
        </StyledAccordionItemHeading>
        <StyledAccordionItemPanel>
          <p>{item.answer}</p>
        </StyledAccordionItemPanel>
      </StyledAccordionItem>
    ))}
  </StyledAccordion>
);

export default FaqList;
